import Head from 'next/head';
import NProgress from 'nprogress';
import { toast } from 'react-toastify';
import { routeKeys, storeKeys } from 'ui/data/constants/keys';
import { labels } from 'ui/data/constants/labels';
import { alertMsgs } from 'ui/data/constants/messages';
import { AuthProvider } from '@cogitate/diep2-components-core';
import {
  loadInitalData,
  loadSelectedLineLob,
  loadStaticItemsFromContainer,
  syncDDMUserDeails,
} from 'ui/utilities/helper';
import { IMAGES_PATH_HELPER } from 'ui/utilities/staticAssetsPaths';
import { useRouter } from 'next/router';
import { setStoreState, getStoreState } from '@cogitate/ui-multi-utils';
export default function Login() {
  const router = useRouter();
  const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);

  const onSuccess = async (userObj, resolvedurl, error) => {
    setStoreState(storeKeys.LoggedInUserReducer, userObj);
    if (!error) {
      const selectedLineLobResult = await loadSelectedLineLob();
      if (selectedLineLobResult.length > 1) {
        window.location.href =
          process.env.NEXT_PUBLIC_PROJECT_URL +
          '/' +
          routeKeys.LobSelection.toLowerCase();
      } else {
        setStoreState(storeKeys.ApplicationReducer, {
          selectedBusinessLine: selectedLineLobResult[0],
          useFullNameForAuditUpdate: true,
        });
        await syncDDMUserDeails(userObj);
        await loadStaticItemsFromContainer();
        await loadInitalData();
        window.location.href =
          process.env.NEXT_PUBLIC_PROJECT_URL +
          routeKeys.DashboardAccountHub.toLowerCase();
      }
    } else {
      toast.error(alertMsgs.Login.LoginFailed);
      router.push(routeKeys.Root);
      NProgress.done();
    }
  };

  return (
    <>
      <Head>
        <title>{labels.Shared.Login.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link rel="icon" href={`${IMAGES_PATH_HELPER}/login-ca.png`} />
      </Head>
      <AuthProvider
        AuthUrl={
          process.env.NEXT_PUBLIC_AUTH_SSO_URL +
          encodeURIComponent(process.env.NEXT_PUBLIC_PROJECT_URL)
        }
        UserStore={loggedInUser}
        onSuccess={onSuccess}
      >
        <div className="processContainer virtualBackground d-flex vh-100 justify-content-center align-items-center">
          <div className="processBox col-4 my-auto text-center pb-5 shadow rounded">
            <h4 className="proHeader py-2" style={{ color: 'black' }}>
              Validating User
            </h4>
            <div className="proBody">
              <div class="lds-ripple my-3">
                <div></div>
                <div></div>
              </div>
              <h5 className="mb-3" style={{ color: 'black' }}>
                Almost there...
              </h5>
            </div>
          </div>
        </div>
      </AuthProvider>
    </>
  );
}

Login.layout = 'L1';
